import React, { useState } from 'react';
import cx from 'classnames';
import {
    AppBar,
    Box,
    Toolbar,
    IconButton,
    Menu,
    Typography
} from '@mui/material';
import { Menu as MenuIcon, AccountCircle } from '@mui/icons-material';
import { makeStyles } from '@material-ui/core';
import SidebarRoutes from './sidebar';
import styles from './header.module.scss';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiAppBar-root': {
            marginTop: 0
        }
    }
}));

export default function MobileHeader({ role, roles, onRoleSwitch, onSignOut,showsiteStatus }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [routesAnchorEl, setRoutesAnchorEl] = useState(null);
    const open = Boolean(routesAnchorEl);
    const handleOpenRoutes = (event) => {
        setRoutesAnchorEl(event.currentTarget);
    };
    const handleCloseRoutes = () => {
        setRoutesAnchorEl(null);
    };

    return (
        <div className={classes.root}>
            <AppBar
                sx={{
                    display: {
                        xs: 'block',
                        sm: 'none'
                    }
                }}
                position="relative"
            >
                <Toolbar position="relative">
                    <IconButton
                        size="medium"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{
                            mr: 2,
                            position: 'relative'
                        }}
                        onClick={handleOpenRoutes}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCloseRoutes}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                        sx={{
                            '& .MuiList-root': {
                                padding: 0
                            },
                            '& .MuiPaper-root': {
                                left:'0px!important',
                                top:showsiteStatus,
                                borderRadius:'0',
                                overflow:'hidden'
                            }
                        }}
                    >
                        <SidebarRoutes
                            role={role.toLowerCase()}
                            onSignOut={onSignOut}
                            onClick={handleCloseRoutes}
                        />
                    </Menu>

                    {/* <Box
                    component="img"
                    sx={{ height: '32px' }}
                    src={IB_LOGO}
                    alt="ib-logo"
                /> */}
                    <Typography variant="h6">IndiaBuys</Typography>
                    <Box sx={{ marginLeft: 'auto' }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                            sx={{
                                padding: 0
                            }}
                        >
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left'
                            }}
                            sx={{
                                '& .MuiList-root': {
                                    padding: '12px 0',
                                    backgroundColor: '#3b4a5d'
                                },
                                '& .MuiPaper-root': {
                                    marginTop: '32px'
                                }
                            }}
                        >
                            {roles.map((el,index) => (
                                <p
                                    key={index}
                                    className={cx(styles.menuItem, {
                                        [styles.active]: role === el
                                    })}
                                    onClick={() => {
                                        role !== el && onRoleSwitch(el);
                                    }}
                                >
                                    Switch as {el}
                                </p>

                                    
                            ))}
                            <p
                                    className={(styles.menuItem)}
                                    onClick={onSignOut}>
                                    Sign Out
                            </p>
                            
                        </Menu>
                    </Box>
                </Toolbar>
            </AppBar>
        </div>
    );
}
